import { render, staticRenderFns } from "./DailyBaseComponent.vue?vue&type=template&id=e252f762&"
import script from "./DailyBaseComponent.vue?vue&type=script&lang=ts&"
export * from "./DailyBaseComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports